import { safelyConsoleError } from './safely-console-error';

/**
 * Creates an array of hour options for a dropdown.
 * If the min/max values are invalid it returns an empty array and logs an error in development.
 * @param min - The minimum hour value (default is 0).
 * @param max - The maximum hour value (default is 23).
 * @returns An array of objects containing value and label for each hour.
 */
export const createHourDropdownOptions = (min: number = 0, max: number = 23) => {
	if (min < 0 || min > 23 || max < 0 || max > 23 || min > max) {
		safelyConsoleError(`Invalid hour dropdown range: min=${min}, max=${max}`);
		return [];
	}

	const length = max - min + 1;
	return Array.from({ length }, (_, i) => {
		const hour = min + i;
		return {
			value: hour.toString().padStart(2, '0'),
			label: hour.toString().padStart(2, '0'),
		};
	});
};
